import * as React from "react";
import { TooltipMessageContent } from "../Tooltip.components";

export const TooltipMessage: React.FunctionComponent = ({
  children,
  ...rest
}) => <TooltipMessageContent {...rest}>{children}</TooltipMessageContent>;
